module.exports = __webpack_public_path__ + "img/IMG_2254_L_Wood.b7f4b400.jpg";